import React from "react";
import { Route } from "react-router-dom";
import PrintPo from "./default/Po";
import PrintInvoice from "./default/Invoice";
import PrintPr from "./default/Pr";
import PrintReceiving from "./default/Receiving";
import PrintReturnGoods from "./default/Return-Goods";
import PrintWHOut from "./default/Warehouse-Out";
import PrintWHIn from "./default/Warehouse-In";
import PrintStockCard from "./default/Stock-Card";
import PrintCashFLow from "./default/Cash-Flow";
import PrintBalanceSheet from "./default/Balance-Sheet";
import PrintIncomeStatement from "./default/Income-Statement";
import PrintWorkSheet from "./default/Work-Sheet";
import PrintGeneralLedger from "./default/General-Ledger";
import PrintJournal from "./default/Journal";
import PrintMemoOut from "./default/Memo-Out";
import PrintMemoIn from "./default/Memo-In";
import PrintPriceComparison from "./default/Price-Comparison";
import PrintNewsEvent from "./default/News-Event";
import PrintSelling from "./default/Selling";


export default function PrintRoutes(props) {
  const { authUser } = props;
  return (
    <>
      {/* Purchasing */}
      <Route path="purchasing">
        <Route path="purchase-order/print/:id" element={<PrintPo />} />
        <Route path="Invoice/print/:id" element={<PrintInvoice />} />
        <Route path="purchase-request/print/:id" element={<PrintPr />} />
        <Route path="receiving/print/:id" element={<PrintReceiving />} />
      </Route>

      {/* Warehouse */}
      <Route path="warehouse">
        <Route path="return-goods/print/:id" element={<PrintReturnGoods />} />
        <Route path="warehouse-out/print/:id" element={<PrintWHOut />} />
        <Route path="warehouse-in/print/:id" element={<PrintWHIn />} />
      </Route>
      {/* Mutation */}
      <Route path="mutation">
        <Route
          path="mutation/print/:branch/:brand/:category/:warehouse/:startDate/:endDate"
          element={<PrintStockCard />}
        />
      </Route>

      {/* Accounting */}
      <Route path="accounting">
        <Route
          path="cash-flow/print/:branch/:month/:year"
          element={<PrintCashFLow />}
        />
        <Route
          path="balance-sheet/print/:branch/:month/:year"
          element={<PrintBalanceSheet />}
        />
        <Route
          path="income-statement/print/:branch/:month/:year"
          element={<PrintIncomeStatement />}
        />
        <Route
          path="work-sheet/print/:branch/:startDate/:endDate"
          element={<PrintWorkSheet />}
        />
        <Route
          path="general-ledger/print/:branch/:startDate/:endDate/:coa3"
          element={<PrintGeneralLedger />}
        />
        <Route path="journal/print/:id" element={<PrintJournal />} />
        <Route path="memo-out/print/:id" element={<PrintMemoOut />} />
        <Route path="memo-in/print/:id" element={<PrintMemoIn />} />
      </Route>

      {/** Report **/}
      <Route path="report">
        <Route
          path="price-comparison/print/:type/:branch/:item"
          element={<PrintPriceComparison />}
        />
        <Route
          path="acceptance-report/print/:id"
          element={<PrintNewsEvent />}
        />
      </Route>

      {/* Sales */}
      <Route path="sales">
        <Route path="selling/print/:id" element={<PrintSelling />} />
      </Route>
    </>
  );
}
